module.exports = __webpack_public_path__ + "fonts/TBCSailec-Bold.bfb27f55.woff";